import BaseRepository from "@/services/resources/repository";
import queryByKeys from "@/services/resources/mixins/query-by-keys";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema).$mix(queryByKeys);
    }

    getWithTestimonials() {
        return this.transformer.many(
            this.try(
                this.baseQuery()
                    .include('testimonial-testimonial-categories.testimonial-categories')
                    .get()
            )
        );
    }
}

export default Repository;
